/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type CmsHomepageBannerFormatEnumType = "BURN_IN" | "CAPTION" | "%future added value";
export type HpRespPromoModulePromoItem_promotion = {
    readonly imageCopy: string | null;
    readonly imageUrl?: string | null;
    readonly imageHeight?: string | null;
    readonly imageWidth?: string | null;
    readonly mobileImageUrl?: string | null;
    readonly mobileImageHeight?: string | null;
    readonly mobileImageWidth?: string | null;
    readonly cta: string | null;
    readonly linkData: {
        readonly path: string | null;
        readonly " $fragmentRefs": FragmentRefs<"HpRespModuleItemTile_linkData" | "HpRespHeroBannerText_linkData" | "SeoLink_linkData">;
    };
    readonly isFullBleedImage: boolean | null;
    readonly title: string | null;
    readonly description: string | null;
    readonly format: CmsHomepageBannerFormatEnumType | null;
    readonly " $fragmentRefs": FragmentRefs<"HpRespSharedHeroBanner_promoItem">;
    readonly " $refType": "HpRespPromoModulePromoItem_promotion";
};
export type HpRespPromoModulePromoItem_promotion$data = HpRespPromoModulePromoItem_promotion;
export type HpRespPromoModulePromoItem_promotion$key = {
    readonly " $data"?: HpRespPromoModulePromoItem_promotion$data;
    readonly " $fragmentRefs": FragmentRefs<"HpRespPromoModulePromoItem_promotion">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "HpRespPromoModulePromoItem_promotion",
  "type": "PromoItem",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isMobile",
      "type": "Boolean"
    }
  ],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "imageCopy",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "cta",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "linkData",
      "storageKey": null,
      "args": null,
      "concreteType": "LinkData",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "path",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "FragmentSpread",
          "name": "HpRespModuleItemTile_linkData",
          "args": null
        },
        {
          "kind": "FragmentSpread",
          "name": "HpRespHeroBannerText_linkData",
          "args": null
        },
        {
          "kind": "FragmentSpread",
          "name": "SeoLink_linkData",
          "args": null
        }
      ]
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "isFullBleedImage",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "title",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "description",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "format",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "Condition",
      "passingValue": false,
      "condition": "isMobile",
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "imageUrl",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "imageHeight",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "imageWidth",
          "args": null,
          "storageKey": null
        }
      ]
    },
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "isMobile",
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "mobileImageUrl",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "mobileImageHeight",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "mobileImageWidth",
          "args": null,
          "storageKey": null
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "HpRespSharedHeroBanner_promoItem",
      "args": null
    }
  ]
};
(node as any).hash = '4e3d1ca619a82baa983dcda4590a393f';
export default node;
